import { useMe } from '../../auth/session';
import { useI18n } from '../../i18n/i18n';
import { AvatarSection } from './avatar-section';
import { EmailSection } from './email-section';
import { GeneralSection } from './general-section';

/** Профиль: имя, язык писем, аватар, email (смена — с подтверждением на новый адрес). */
export function ProfilePage() {
  const { t } = useI18n();
  const me = useMe();
  const profile = me.data;
  if (profile === null || profile === undefined) return null;
  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold">{t('profile.title')}</h1>
      <GeneralSection profile={profile} />
      <AvatarSection profile={profile} />
      <EmailSection profile={profile} />
    </div>
  );
}
